// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.content {
  display: flex;
  flex: 1 1;
  position: relative;
}

.main-content {
  flex: 1 1;
  transition: margin-left 0.3s ease;
  /* padding: 20px; */
}

.main-content.sidebar-open {
  margin-left: 250px; /* Adjust this value if needed */
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-border {
  width: 3rem;
  height: 3rem;
}

.sidebar-toggle-button {
  display: none;
  position: absolute;
  top: 10px;
  left: 10px;
  background: #496c58;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1001;
}

@media (max-width: 768px) {
  .sidebar {
    display: none;
  }

  .sidebar.open {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 1000;
    /* background: white; */
    width: 67vw;
  }

  .sidebar-toggle-button {
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".home {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n}\r\n\r\n.content {\r\n  display: flex;\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  transition: margin-left 0.3s ease;\r\n  /* padding: 20px; */\r\n}\r\n\r\n.main-content.sidebar-open {\r\n  margin-left: 250px; /* Adjust this value if needed */\r\n}\r\n\r\n.loader-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.spinner-border {\r\n  width: 3rem;\r\n  height: 3rem;\r\n}\r\n\r\n.sidebar-toggle-button {\r\n  display: none;\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 10px;\r\n  background: #496c58;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  z-index: 1001;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .sidebar {\r\n    display: none;\r\n  }\r\n\r\n  .sidebar.open {\r\n    display: flex;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    height: 100%;\r\n    z-index: 1000;\r\n    /* background: white; */\r\n    width: 67vw;\r\n  }\r\n\r\n  .sidebar-toggle-button {\r\n    display: block;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
